module.exports = __webpack_public_path__ + "static/img/lord-of-flies.c3346c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/lord-of-flies.jpg
// module id = qxTc
// module chunks = 1